import { render, staticRenderFns } from "./Runit.vue?vue&type=template&id=5c0dcf9e"
import script from "./Runit.vue?vue&type=script&lang=js"
export * from "./Runit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports